import { render, staticRenderFns } from "./BaseTableSpinner.vue?vue&type=template&id=d176061c&"
import script from "./BaseTableSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseTableSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports